// ----------------------------------------------------------------------
// Cross-cutting business constants shared by hooks, components and pages.
// ----------------------------------------------------------------------

/**
 * Slug of the "Entreprenariat" formation category.
 *
 * This category is intentionally kept out of the generic catalog experience:
 * its formations are only surfaced on the dedicated /entrepreneurship page,
 * and the category itself is hidden from generic category lists (catalog
 * selector, search bar, navbar, footer). See `useGetFormations` and
 * `useGetCategories` where this rule is applied.
 */
export const ENTREPRENEURSHIP_CATEGORY_SLUG = 'entreprenariat';
